<style lang="scss">

</style>

<!-- eslint-disable -->
<template>
  <b-card>
    <p class="font-weight-bolder">Termination Reasons</p>

    <section class="call-stats__items" v-if="!loading">
      <section class="d-flex full-width">
        <div class="ui-spacer"></div>
        <p class="text-right brand-color font-weight-bold">
          Total Terminated: {{stats.totalTerminated}}
        </p>
      </section>

      <section v-if="stats.totalTerminated">
        <b-table
          class="data-table mt-2"
          hover
          :fields="headers"
          :items="tableStats"
          :per-page="-1">
        </b-table>
      </section>
    </section>

    <section v-else class="d-flex justify-center pb-6 pt-8 flex-wrap">
      <p class="full-width d-flex justify-content-center"><b-spinner variant="primary"></b-spinner>
        <span class="d-inline-block ml-2">Getting Stats...</span>
      </p>
    </section>
  </b-card>
</template>
<!-- eslint-enable -->

<script>
  import { mapState } from 'vuex';
  import BiStatsService from '../../../services/BiStatsService';
  import HelperService from '../../../services/HelperService';

  export default {
    components: {
      // StatisticCardWithLineChart,
    },
    props: {
      filters: {
        required: true,
        type: Object,
      },
    },
    data() {
      return {
        helperService: new HelperService(),
        loading: true,
        stats: null,
        tableStats: [],
        colors: [],
        chart: {
          series: {
            name: 'Termination Reasons',
            data: [],
          },
          annotate: {
            text: '',
            value: null,
          },
        },
        headers: [
          { label: 'Reason', key: 'reason' },
          { label: 'Total', key: 'total' },
        ],
      };
    },
    computed: {
      ...mapState({
        compareMode: state => state.stats.compareMode,
      }),
    },
    watch: {
      filters: {
        handler() {
          this.getTerminationStats();
        },
        deep: true,
      },
    },
    mounted() {
      this.colors = this.helperService.getChartColors();
      this.getTerminationStats();
    },
    methods: {
      getTerminationStats() {
        this.loading = true;

        BiStatsService.getVisitorTerminatedReasons(this.filters).then(res => {
          this.stats = res.data;
          // this.setUpChart(this.stats.reasons);
          this.setUpTableStats(this.stats.reasons);
        }).catch(err => {
          console.log('could not get busiest day', err);
          this.$toast.error('Could not get busiest day stats, please refresh and try again', {
            toastClassName: ['toast-std', 'warning-toast'],
          });
        }).finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        });
      },
      setUpChart(reasons) {
        this.chart.series.data = []; // reset data

        // eslint-disable-next-line guard-for-in,no-restricted-syntax
        for (const reasonKey in reasons) {
          this.chart.series.data.push({
            x: reasonKey === 'undefined' ? 'Not specified' : reasonKey,
            y: reasons[reasonKey],
          });
        }
      },
      setUpTableStats(reasons) {
        this.tableStats = [];

        // eslint-disable-next-line guard-for-in,no-restricted-syntax
        for (const reasonKey in reasons) {
          this.tableStats.push({
            reason: reasonKey === 'undefined' ? 'Not specified' : reasonKey,
            total: reasons[reasonKey],
          });
        }
      },
    },
  };
</script>
